import React from "react";
import { Box, Typography, List, ListItem, ListItemIcon } from "@mui/material";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord"; // Bullet point icon

const Cookies = () => {
  return (
    <Box sx={{ maxWidth: 800, margin: "0 auto", padding: 3 }}>
      <Typography variant="h3" gutterBottom>
        Cookie Policy
      </Typography>
      <Typography variant="body1" paragraph>
        Last updated: 15/02/2025
      </Typography>
      <Typography variant="body1" paragraph>
        This Cookie Policy explains how we use cookies and similar technologies
        on our website.
      </Typography>

      <Typography variant="h5" gutterBottom>
        1. What Are Cookies?
      </Typography>
      <Typography variant="body1" paragraph>
        Cookies are small text files stored on your device when you visit a
        website. They help us improve your browsing experience and understand
        how you use our site.
      </Typography>

      <Typography variant="h5" gutterBottom>
        2. Types of Cookies We Use
      </Typography>
      <Typography variant="body1" paragraph>
        We use the following types of cookies:
      </Typography>
      <List>
        <ListItem>
          <ListItemIcon sx={{ minWidth: 24 }}>
            <FiberManualRecordIcon sx={{ fontSize: "small" }} />
          </ListItemIcon>
          <Typography variant="body1">
            <strong>Essential Cookies:</strong> Necessary for the website to
            function properly.
          </Typography>
        </ListItem>
        <ListItem>
          <ListItemIcon sx={{ minWidth: 24 }}>
            <FiberManualRecordIcon sx={{ fontSize: "small" }} />
          </ListItemIcon>
          <Typography variant="body1">
            <strong>Analytics Cookies:</strong> Help us analyze how users
            interact with our website.
          </Typography>
        </ListItem>
        <ListItem>
          <ListItemIcon sx={{ minWidth: 24 }}>
            <FiberManualRecordIcon sx={{ fontSize: "small" }} />
          </ListItemIcon>
          <Typography variant="body1">
            <strong>Marketing Cookies:</strong> Used to deliver relevant ads and
            track campaign performance.
          </Typography>
        </ListItem>
      </List>

      <Typography variant="h5" gutterBottom>
        3. Managing Cookies
      </Typography>
      <Typography variant="body1" paragraph>
        You can manage or disable cookies through your browser settings.
        However, this may affect your experience on our website.
      </Typography>

      <Typography variant="h5" gutterBottom>
        4. Changes to This Policy
      </Typography>
      <Typography variant="body1" paragraph>
        We may update this Cookie Policy from time to time. Any changes will be
        posted on this page.
      </Typography>
    </Box>
  );
};

export default Cookies;
